<div class="container my-3 p-3 General container-fluid" style="position: relative;">
  <h3>{{'AnnualReport.SearchTitle' | translate}}</h3>
  @for (item of items; track item) {
    <div class="list-group">
      <app-pdf-url-row>
        <a href="{{item.fileUrl}}" target="_blank">
          <div style="display: flex; flex-direction: row; gap: 15px; width: 100%">
            <h1>{{item.year}}</h1>
            <div class="col-10 d-flex align-items-center p-0">
              @if (item.id == 16 || item.id == 18 || item.id == 19) {
                <p><strong>{{'AnnualReport.Assessed' | translate}}</strong> <br> <span>{{item.reportDate}}</span></p>
              }
              @if (item.id != 16 && item.id != 18 && item.id != 19) {
                <p><strong>{{'AnnualReport.Annual' | translate}}</strong> <br> <span>{{item.reportDate}}</span></p>
              }
            </div>
          </div>
        </a>
      </app-pdf-url-row>
    </div>
  }
</div>
